import Axios from 'axios';
import modules from './modules/index.js';
import video_interview_groups from './videoInterviewGroups.js';

export default {
  modules: {
    modules,
    video_interview_groups
  },

  namespaced: true,

  state() {
    return {
      item: {},
      loaded: false,
      vacancyTests: null
    };
  },

  mutations: {
    set_prop(state, data) {
      state.item[data.key] = data.v;
    },

    set_item(state, v) {
      if (v.meta && v.meta.active_process === 'bat-personal-account') {
        v.meta.active_process = 'bat';
      }
      if (v.meta && v.meta.active_process === 'deloitte-sf') {
        v.meta.active_process = 'deloitte';
      }
      if (v.meta && v.meta.active_process === 'questionnaire-landing') {
        v.meta.active_process = 'questionnaire';
      }
      state.item = v;
    },

    set_loaded(state, v) {
      state.loaded = v;
    },

    setVacancyTests(state, data) {
      state.vacancyTests = data;
    },

    SET_VIDEO_LINK(state, data) {
      if (data) {
        state.item.video_link = data;
      } else {
        state.item.video_link = '';
      }
    },

    SET_VIDEO_LANDING(state, data) {
      state.item.is_video_landing = data;
    }
  },

  actions: {
    load({ commit }, id) {
      commit('set_loaded', false);

      return Axios.get(`/1.0/vacancies/${id}`)
        .then(r => {
          commit('set_item', r.data.data[0]);
          commit('set_loaded', true);
        })
        .catch(e => Promise.reject(e));
    },

    save({ commit }, data) {
      // data - object vacancy
      let keys = Object.keys(data);

      keys.forEach(i => {
        commit('set_prop', {
          key: i,
          v: data[i]
        });
      });

      return Axios.put('/1.0/vacancies', { vacancies: [data] })
        .then(r => {
          commit('set_item', r.data.data[0]);
        })
        .catch(e => Promise.reject(e));
    }
  },

  getters: {
    item: state => state.item,
    companyId: state => state.item.company.id,
    loaded: state => state.loaded,
    process: state => (state.item.meta ? state.item.meta.active_process : null)
  }
};
